import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
import useIsMobile from "@hooks/useIsMobile";
import useHelpers from "@hooks/useHelpers";
import React from "react";
import { trackEvents } from "@/common/events/events";
var OilSearchBanner = function OilSearchBanner(_ref) {
  var referral_location = _ref.referral_location;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var isMobile = useIsMobile();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var desktopImage = "/assets/images/homepage/oil/oil_home_banner_desktop_".concat(lang, ".png");
  var mobileImage = "/assets/images/homepage/oil/oil_home_banner_mobile.png";
  return /*#__PURE__*/React.createElement("div", {
    className: "md:mx-2 lg:max-w-[1320px] lg:mx-auto lg:my-0 lg:py-2.5"
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/products/oil"),
    className: "block rounded-2xl overflow-hidden relative",
    onClick: (/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              e.preventDefault();
              _context.n = 1;
              return trackEvents("vas_listing_viewed", {
                vas_category: "oil",
                referral_location: referral_location
              });
            case 1:
              window.location.href = createUrl("/products/oil");
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }())
  }, /*#__PURE__*/React.createElement("img", {
    src: isMobile ? mobileImage : desktopImage,
    alt: "Oil banner",
    className: "w-full min-h-[400px] md:h-[280px] md:min-h-[280px] object-cover"
  }), isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 inset-x-0 flex flex-col items-center text-center px-4 pt-6 gap-2"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary-new text-2xl font-bold leading-snug mb-1 px-4"
  }, tShort("oil_banner_heading_line1", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-primary-new text-lg leading-snug mb-1"
  }, tShort("oil_banner_heading_line2", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-500 text-xs mb-3"
  }, tShort("oil_banner_terms", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer bg-primary-new text-white text-xs font-bold px-8 py-2 rounded border-none"
  }, tShort("oil_banner_cta", {
    ns: "web_home"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 bottom-0 w-[58%] flex flex-col justify-center gap-4 items-start ".concat(lang === "ar" ? "left-0 text-right " : "right-0 text-left ")
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary-new text-4xl font-bold leading-snug"
  }, tShort("oil_banner_heading_line1", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-primary-new text-2xl font-semibold leading-snug"
  }, tShort("oil_banner_heading_line2", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-500 text-base md:my-2"
  }, tShort("oil_banner_terms", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("button", {
    className: "cursor-pointer bg-primary-new text-white text-[clamp(0.625rem,0.9vw,0.875rem)] font-bold px-8 py-2 rounded min-w-[133px] border-none"
  }, tShort("oil_banner_cta", {
    ns: "web_home"
  })))));
};
export default OilSearchBanner;